export default class ActivityTimer {
	_timer
	_idleCheckMs
	_listening = false
	_active = false
	_stop = null
	_interval

	onInterval = () => {
		if (!this._active) this._timer.stop()
		this._active = false
	}

	onActivity = () => {
		if (!this._active) this._timer.start()
		this._active = true
	}

	constructor({ timer, idleCheckMs }) {
		this._timer = timer
		this._idleCheckMs = idleCheckMs
	}

	start() {
		document.addEventListener('mousemove', this.onActivity)
		document.addEventListener('keydown', this.onActivity)
		this._stop = null
		this._timer.start()
		this._interval = setInterval(this.onInterval, this._idleCheckMs)
	}

	stop() {
		this._stop = new Date()
		if (this._interval) {
			document.removeEventListener('mousemove', this.onActivity)
			document.removeEventListener('keydown', this.onActivity)
			this._timer.stop()
			clearInterval(this._interval)
		}
	}

	getTimes() {
		const times = this._timer.getTimes()
		if (times) {
			const stop = this._stop || new Date()
			const { start, accumulated } = times
			const elapsed = stop - start
			return { start, stop, elapsed, accumulated }
		}
	}
}



// WEBPACK FOOTER //
// ./../jump-common/timers/ActivityTimer.js